export default {
  MY_INVESTMENT_GET_FILE_QUERY: Symbol.for('MY_INVESTMENT_GET_FILE_QUERY'),
  MY_INVESTMENT_FILE_REPOSITORY: Symbol.for('MY_INVESTMENT_FILE_REPOSITORY'),
  MY_INVESTMENT_FILE_STATE_MANAGER: Symbol.for('MY_INVESTMENT_FILE_STATE_MANAGER'),
};
